export const ICONIFY = {
    edit: 'eva:edit-fill',
    city: 'solar:city-bold-duotone',
    launch: 'ic:outline-launch',
    tick: 'charm:tick',
    close: 'charm:cross',
    asterisk: 'mdi:asterisk',
    numeric: 'mdi:numeric',
    minSize: 'mdi:format-letter-starts-with',
    maxSize: 'mdi:format-letter-ends-with',
    TEXT_FIELD: 'solar:text-bold',
    DROPDOWN: 'mdi:form-dropdown',
    CALENDAR: 'mdi:calendar-clock',
    RADIO: 'mdi:radiobox-marked',
    CHECKBOX: 'mdi:checkbox-multiple-outline',
    TEXT_AREA: 'mdi:form-textarea',
    RATING: 'mdi:star',
    IMAGELIST: 'mdi:image-multiple',
    DROPDOWN_TEXT_FIELD: 'mdi:script-text',
    exclamation: 'mdi:exclamation-thick',
    regex: 'mdi:regex',
    filter: 'mdi:filter',
    drag: 'mdi:drag',
    clone: 'mdi:content-copy',
}
